module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "offline.d474c3f3.png";